import { useContext, useEffect } from "react";
import useFirestore from "./basic/useFirestore";
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { FirebaseContext } from "../providers/FirebaseProvider/FirebaseProvider";

function useUserBookings(
  userId,
  fromDate,
  toDate = new Date(2100, 1, 1),
  maxResults = 1000,
) {
  const { firestoreDb } = useContext(FirebaseContext);

  const toDatePlusOneDay = new Date(toDate);
  toDatePlusOneDay.setDate(toDatePlusOneDay.getDate() + 1);
  toDatePlusOneDay.setHours(0, 0, 0, 0);

  const firestoreQuery = () =>
    getDocs(
      query(
        collection(firestoreDb, "prenotazioni"),
        where("participantUserIds", "array-contains", userId),
        where("from", ">=", fromDate),
        where("from", "<=", toDate),
        orderBy("from", "asc"),
        limit(maxResults),
      ),
    );

  const parsingFuntion = (data) => {
    return data.docs.map((doc) => {
      return {
        id: doc.id,
        ...doc.data(),
      };
    });
  };

  const { data, error, isLoading, refreshData } = useFirestore(
    firestoreQuery,
    parsingFuntion,
  );

  useEffect(() => {
    refreshData();
  }, [userId]);

  return {
    data,
    error,
    isLoading,
    refreshData,
  };
}

export default useUserBookings;
